import { apiWithToken } from '../api';

const resouceUrl = '/relatorio_vistoria';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const show = async (processo_id) => {
  return await api.get(`${resouceUrl}/${processo_id}`);
}

export const update = async (id, relatorio_vistoria) => {
  return await api.put(`${resouceUrl}/${id}`, relatorio_vistoria);
}

export const store = async (relatorio_vistoria) => {
  let response = await api.post(resouceUrl , relatorio_vistoria);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}
